import { waitForTruthyVal } from '../helpers/utils';

waitForTruthyVal(() => typeof window.QuantumMetricAPI?.getSessionID === 'function' && window.QuantumMetricAPI.getSessionID(), 500, 20)
  .then((sessionId) => {
    const hiddenInput = document.querySelector('input[name="contact[session tag]"]');
    if (hiddenInput) {
        hiddenInput.value = sessionId;
    } else {
        console.warn('Hidden input element not found');
    }
  }).catch(err => {
    console.warn("Could not get QM session ID.", err);
  });